import { MutationTree } from 'vuex';
import * as MT from './mutationsTypes';
import {
  ClearFilterParams,
  FilterData,
  FilterDataMutationParams,
  FilterParams,
  IFilterState
} from '@/components/ui/filters/store/types';
import { Vue } from 'vue-property-decorator';

/*--------------------------------------------------/
 * Filter Mutations
 *--------------------------------------------------*/
export const FilterMutations: IFilterMutations = {
  [MT.SET_IS_LOADING](
    state: IFilterState,
    params: Pick<FilterParams, 'name' | 'searchTerm'>
  ) {
    const { name, searchTerm } = params;
    if (!state[name]) {
      Vue.set<Record<string, FilterData>>(state, name, {});
    }
    if (!state[name][searchTerm]) {
      Vue.set<FilterData>(state[name], searchTerm, {
        data: [],
        currentPage: 0,
        totalPages: -1,
        totalCount: -1,
        isFetchingData: false
      });
    }

    Vue.set<FilterData>(state[name], searchTerm, {
      ...state[name][searchTerm],
      isFetchingData: true
    });
  },

  [MT.SET_FILTER_DATA](state: IFilterState, params: FilterDataMutationParams) {
    const {
      name,
      searchTerm,
      currentPage,
      totalPages,
      totalCount,
      data
    } = params;
    if (!state[name]) {
      Vue.set<Record<string, FilterData>>(state, name, {});
    }
    if (!state[name][searchTerm]) {
      Vue.set<FilterData>(state[name], searchTerm, {
        data: [],
        currentPage: 0,
        totalPages: -1,
        totalCount: -1,
        isFetchingData: false
      });
    }
    Vue.set<FilterData>(state[name], searchTerm, {
      ...state[name][searchTerm],
      data:
        currentPage === 1 ? data : [...state[name][searchTerm].data, ...data],
      currentPage,
      totalPages,
      totalCount
    });
  },

  [MT.CLEAR_FILTER_DATA](state, options: ClearFilterParams) {
    const { name } = options;
    const cached = state[name];
    if (!cached) {
      return;
    }

    Vue.delete(state, name);
  },

  [MT.SET_DONE_LOADING](
    state,
    params: Pick<FilterParams, 'name' | 'searchTerm'>
  ) {
    const { name, searchTerm } = params;
    if (!state[name]) {
      Vue.set<Record<string, FilterData>>(state, name, {});
    }
    if (!state[name][searchTerm]) {
      Vue.set<FilterData>(state[name], searchTerm, {
        data: [],
        currentPage: 0,
        totalPages: -1,
        totalCount: -1,
        isFetchingData: false
      });
    }
    Vue.set<FilterData>(state[name], searchTerm, {
      ...state[name][searchTerm],
      isFetchingData: false
    });
  }
};

/*--------------------------------------------------/
 * Filter Mutations Tree Type
 *--------------------------------------------------*/
export interface IFilterMutations extends MutationTree<IFilterState> {}
